import React, { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withInjectParams } from '../../utils/InjectParams'
import { fetchSessionTeam, preselectTeam, selectPage, selectUser } from '../../../store/session'
import { selectAPIParams } from '../../../store/site'
import { selectTeam } from '../../../store/team'

import Button from '../../ui/Button'
import ConfirmTeamModal from '../ConfirmTeamModal'
import LinkHandler from '../../utils/LinkHandler'

const JoinTeam = ({
  apiParams: { excludeTeamIds },
  background,
  fetchSessionTeam,
  foreground,
  injectParams,
  label,
  page = {},
  preselectTeam,
  team,
  url,
  user
}) => {
  const [confirm, setConfirm] = useState(false)

  const button = {
    children: injectParams(label),
    background,
    foreground
  }

  const hideButton = ['id', 'slug'].reduce((current, key) => {
    if (!team[key]) return current
    return current || (excludeTeamIds && excludeTeamIds.indexOf(team[key].toString()) > -1)
  }, false)

  if (hideButton) return null

  return (
    <React.Fragment>
      {!page.teamPageId && (
        <Button
          {...button}
          tag={LinkHandler}
          to={injectParams(url)}
          onClick={e => {
            if (page.id) {
              e.preventDefault()
              return setConfirm(true)
            }

            preselectTeam(team.id)
          }}
        />
      )}
      {confirm && (
        <ConfirmTeamModal
          campaign={team.campaign}
          modal={{ isOpen: confirm, onRequestClose: () => setConfirm(false) }}
          pageId={page.uuid}
          pageSlug={page.slug}
          onSuccess={team => fetchSessionTeam(team)
            .then(() => window.location.reload())}
          teamId={team.id}
          token={user.token}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  ...selectAPIParams(state),
  page: selectPage(state),
  team: selectTeam(state),
  user: selectUser(state)
})

const mapDispatchToProps = { fetchSessionTeam, preselectTeam }

export default compose(
  withInjectParams,
  connect(mapStateToProps, mapDispatchToProps)
)(JoinTeam)
